

import React, { lazy, Suspense} from "react";

import DefaultLoader from "../../utilities/loaders/DefaultLoader";
const MyRequestsContent = lazy(() => import('./TrackRequestsContent'));



const TrackRequests = () => {

    return (  
        <Suspense fallback={<DefaultLoader />}>
            <MyRequestsContent  />
        </Suspense>
    );
}

export default TrackRequests;
